import {axios} from "../../helpers/axios";
import { STAGE_URL } from "./stageConstants";

export const api_get_stage_list_url = async (page,limit,qn,qs) => {
    return axios.get(STAGE_URL, { params: {page,limit,qn,qs}});
};

export const api_create_stage_url = async (data) => {
    return axios.post(STAGE_URL, data);
};

export const api_update_stage_url = async (stage_id,updated_data) => {
    return axios.put(STAGE_URL + "/" + stage_id,updated_data);
};

export const api_activate_deactivate_stage_url = async (stage_id,updated_data) => {
    return axios.patch(STAGE_URL + "/" + stage_id + "/" + updated_data);
};

export const api_get_stage_details_url = async (stage_id) => {
    return axios.get(STAGE_URL + "/" + stage_id);
};